var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      class: [
        "btn",
        "add-to-wishlist",
        "add-to-wishlist--heart",
        { "add-to-wishlist--filled": _vm.isInWishlist }
      ],
      attrs: {
        type: "button",
        "data-action-add": _vm.addToWishlistUrl,
        "data-action-remove": _vm.removeFromWishlistUrl,
        "data-pid": _vm.isUniqueSize
          ? _vm.uniqueSizeVariantPid
          : _vm.variationGroupIdData,
        "data-default-error-msg": _vm.$msg("wishlist.default.error", "wishlist")
      },
      on: { click: _vm.buttonHandler }
    },
    [
      _c("span", { staticClass: "default-content visually-hidden" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.$msg("button.add_to_wishlist.txt", "wishlist", null)) +
            "\n  "
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }